module.exports = __webpack_public_path__ + "img/b3-3.2f0e8c1.png";